import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class AdminService {
  http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  getErrorLogs() {
    return this.http.get("/Admin/GetErrorLogs").toPromise();
  }

  getConfigCat() {
    return this.http.get("/Admin/GetConfigCat").toPromise();
  }

  getLoginUrl(selectedCompany: any) {
    return this.http.get("/Admin/GetLoginUrl?co=" + selectedCompany, { responseType: 'text' }).pipe();
  }

  getUserGroup() {
    return this.http.get("/Admin/GetUserGroup").toPromise();
  }

  getAllEmailTemplates() {
    return this.http.get("/Admin/GetAllEmailTemplates").toPromise();
  }

  getLookup() {
    return this.http.get("/Checklist/GetLookup").toPromise();
  }

  getAttachmentTypes() {
    return this.http.get("/Checklist/GetAttachmentTypes").toPromise();
  }

  getCompanies() {
    return this.http.get("/Admin/GetCompanies").toPromise();
  }

  getVersionNumber() {
    return this.http.get("/Admin/GetVersionNumber").toPromise();
  }

  getCounts() {
    return this.http.get("/Admin/GetCounts").toPromise();
  }

  getCustomerId() {
    return this.http.get("/Admin/GetCustomerId").toPromise();
  }

  getPortalSettings() {
    return this.http.get("/Admin/GetPortalSettings").toPromise();
  }

  getAllPortalSettings() {
    return this.http.get("/Admin/GetAllPortalSettings").toPromise();
  }

  getPortalSettingUpdateLogs(portalSetting: string, count: number) {
    return this.http.get("/Admin/GetPortalSettingUpdateLogs?portalSetting=" + portalSetting + "&count=" + count).toPromise();
  }

  savePortalSettings(configName: any, configValue: any) {
    return this.http.post("/Admin/SavePortalSettings",
      {
        settingName: configName,
        settingValue: configValue
      }).toPromise();
  }

  portalSettingsPageData() {
    return this.http.get("/Admin/PortalSettingsPageData").toPromise();
  }

  getVersionHistory() {
    return this.http.get("/Admin/GetVersionHistory").toPromise();
  }

  sendUsageDataTask() {
    return this.http.post("/Admin/SendUsageDataTask", {}).toPromise();
  }

  refreshPortalSettings() {
    return this.http.post("/Admin/RefreshPortalSettings", {}).toPromise();
  }

  refreshSynonyms() {
    return this.http.post("/Admin/RefreshSynonyms", {}).toPromise();
  }

  refreshDynamicViews() {
    return this.http.post("/Admin/RefreshDynamicViews", {}).toPromise();
  }

  purgeVCMSessions() {
    return this.http.post("/Admin/PurgeVCMSessions", {}).toPromise();
  }

  previewUserGroupMembers(userGroupID: any, isUpdatePersist: any) {
    return this.http.get("/Admin/PreviewUserGroupMembers?userGroupID=" + userGroupID + "&isUpdatePersist=" + isUpdatePersist).toPromise();
  }

  checkExistRDL(filename: any) {
    return this.http.post("/Admin/CheckExistRDL",
      {
        filename: filename
      }).toPromise();
  }

  uploadCustomRDL(configName: any, configValue: any, fileData: any) {
    return this.http.post("/Admin/UploadCustomRDL",
      {
        settingName: configName,
        settingValue: configValue,
        fileData: fileData
      }).toPromise();
  }

  deleteCustomRDL(filename: any, configName: any) {
    return this.http.post("/Admin/DeleteCustomRDL",
      {
        filename: filename,
        settingName: configName
      }).toPromise();
  }

  builderCustomRDLAction(fileName: any, fileData: any, deleteList: any) {
    return this.http.post("/Admin/BuilderCustomRDLAction",
      {
        fileName: fileName,
        fileData: fileData,
        deleteList: deleteList
      }).toPromise();
  }

  updateConfigInfo(configName: any, description: any, helperText: any, isAdvanced: any, moduleSubID: any, defaultValue: any, regularExpression: any) {
    return this.http.post("/Admin/UpdateConfigInfo",
      {
        configName: configName,
        description: description,
        helperText: helperText,
        isAdvanced: isAdvanced,
        moduleSubID: moduleSubID,
        defaultValue: defaultValue,
        regularExpression: regularExpression
      }).toPromise();
  }

  birdDogTalentUserInsert() {
    return this.http.post("/Hiring/BirdDogTalentUserInsert", {}).toPromise();
  }

  deleteTempFilesAction() {
    return this.http.post("/Document/DeleteTempFilesAction", {}).toPromise();
  }

  clearCoLogoCache() {
    return this.http.post("/Company/ClearCoLogoCache", {}).toPromise();
  }

  getBulletinType(bulletinGroupType?: string) {
    return this.http.get("/Admin/GetBulletinType?bulletinGroupType=" + bulletinGroupType).toPromise();
  }

  getAllBulletinType() {
    return this.http.get("/Admin/GetBulletinType").toPromise();
  }

  getBulletinsManage() {
    return this.http.get("/Admin/GetBulletinsManage").toPromise();
  }

  deleteBulletin(bulletinID: number) {
    return this.http.post("/Admin/DeleteBulletin",
      {
        bulletinID: bulletinID
      }).toPromise();
  }

  bulletinSendPendingReminder(bulletinID: number) {
    return this.http.post("/Admin/BulletinSendPendingReminder",
      {
        bulletinID: bulletinID
      }).toPromise();
  }

  getDBAttachment(BulletinThumbFileAttachmentID: any) {//TODo Move to DocumentService
    return this.http.get("/Document/GetDBAttachment?attachmentID=" + BulletinThumbFileAttachmentID).toPromise();
  }

  getDBAttachmentList(moduleID: number, bulletinID?: number, recordGuid?: any, onboardingUser?: boolean) {//TODo Move to DocumentService
    return this.http.get("/Document/GetDBAttachmentList?moduleID=" + moduleID + "&recordID=" + bulletinID + "&recordGuid=" + recordGuid + "&onboardingUser=" + onboardingUser).toPromise();
  }

  addEditBulletin(requestObj: { [key: string]: any; }) {
    return this.http.post("/Admin/AddEditBulletin",
      {
        bulletinID: requestObj.bulletinID,
        bulletinAttachDocumentFlagValue: requestObj.bulletinAttachDocumentFlagValue,
        bulletinHeadline: requestObj.bulletinHeadline,
        bulletinBody: requestObj.bulletinBody,
        bulletinExpiresString: requestObj.bulletinExpiresString,
        bulletinThumbnailText: requestObj.bulletinThumbnailText,
        bulletinThumbFileAttachmentID: requestObj.bulletinThumbFileAttachmentID,
        bulletinMode: requestObj.bulletinMode,
        bulletinTypeID: requestObj.bulletinTypeID,
        bulletinDirectURL: requestObj.bulletinDirectURL,
        bulletinStartDateStr: requestObj.bulletinStartDateStr,
        embedAttachmentInPage: requestObj.embedAttachmentInPage,
        bulletinIgnoreDateString: requestObj.bulletinIgnoreDateString,
        bulletinSignatureText: requestObj.bulletinSignatureText,
        bulletinIsPinned: requestObj.bulletinIsPinned,
        attachmentType: requestObj.attachmentType,
        bulletinIsSecure: requestObj.bulletinIsSecure,
        isFillablePDF: requestObj.isFillablePDF
      }).toPromise();
  }

  getBulletinGroup(bulletinTypeID?: number, bulletinID?: number) {
    return this.http.get("/Admin/GetBulletinGroup?bulletinTypeID=" + bulletinTypeID + "&bulletinID=" + bulletinID).toPromise();
  }

  setBulletinGroup(bulletinTypeID?: number, bulletinID?: number, userGroupID?: number) {
    return this.http.post("/Admin/SetBulletinGroup", {
      bulletinTypeID: bulletinTypeID,
      bulletinID: bulletinID,
      userGroupID: userGroupID
    }).toPromise();
  }

  removeBulletinGroup(userGroupBulletinTypeID: number) {
    return this.http.post("/Admin/RemoveBulletinGroup", {
      userGroupBulletinTypeID: userGroupBulletinTypeID
    }).toPromise();
  }

  saveDBAttachment(moduleID, recordID, attachmentFileData, attachmentFileName) {
    return this.http.post("/Document/SaveDBAttachment", {
      moduleID: moduleID,
      recordID: recordID,
      attachmentFileData: attachmentFileData,
      attachmentFileName: attachmentFileName
    }).toPromise();
  }

  userGroupAddSingleUser(userGroupID: number, userGroupName: any, fliterInactive: boolean, sQLQueryOverride: any, pRCo: any, memberType: string, isIncluded: boolean, groupValue: any) {
    return this.http.post("/Admin/UserGroupAddSingleUser", {
      userGroupID: userGroupID,
      userGroupName: userGroupName,
      fliterInactive: fliterInactive,
      sQLQueryOverride: sQLQueryOverride,
      pRCo: pRCo,
      memberType: memberType,
      isIncluded: isIncluded,
      groupValue: groupValue
    }).toPromise();
  }

  removeBulletinType(bulletinTypeID: number) {
    return this.http.post("/Admin/RemoveBulletinType", {
      bulletinTypeID: bulletinTypeID
    }).toPromise();
  }

  setBulletinType(bulletinTypeID: number, bulletinName: string, bulletinGroupType: string) {
    return this.http.post("/Admin/SetBulletinType", {
      bulletinTypeID: bulletinTypeID, bulletinName: bulletinName, bulletinGroupType: bulletinGroupType
    }).toPromise();
  }

  getBulletinTrackResponses(bulletinID?: number, pREHKeyID?: number) {
    return this.http.get("/Admin/GetBulletinTrackResponses?bulletinID=" + bulletinID + "&pREHKeyID=" + pREHKeyID).toPromise();
  }

  bulletinAttachToVista(bulletinID: number, bulletinAttachDocumentFlagValue: string, filename: string, PREHKeyID?: number, HRRMKeyID?: number, bulletinResponseID?: number) {
    return this.http.post("/Employee/BulletinAttachToVista", {
      bulletinID: bulletinID, bulletinAttachDocumentFlagValue: bulletinAttachDocumentFlagValue, filename: filename, PREHKeyID: PREHKeyID, HRRMKeyID: HRRMKeyID, bulletinResponseID: bulletinResponseID
    }).toPromise();
  }

  getHRUsers(searchText: string, includeInactive: boolean, userKeyID: number) {
    var url = "/Admin/GetHRUsers?searchText=" + searchText + "&includeInactive=" + includeInactive + "&userKeyID=" + userKeyID;
    return this.http.get(url).toPromise();
  }

  getBulletinsGetIndex(bulletinID?: number) {
    var url = "/Employee/GetBulletinsGetIndex?bulletinID=" + bulletinID;
    return this.http.get(url).toPromise();
  }

  getEmployees(includeInactive: boolean, isAdd: boolean, jcjm: number) {
    var url = "/Admin/GetEmployees?includeInactive=" + includeInactive + "&isAdd=" + isAdd + "&jcjm=" + jcjm;
    return this.http.get(url).toPromise();
  }

  getCodes(selectedCompany: number) {
    var url = "/Admin/GetCodes?hRCo=" + selectedCompany;
    return this.http.get(url).toPromise();
  }

  clearUserGridSettings(gridLocation: string, userKeyID?: number) {
    return this.http.post("/Admin/ClearUserGridSettings", {
      userKeyID: userKeyID,
      gridLocation: gridLocation
    }).toPromise();
  }

  getScheduledJobs() {
    var url = "/Admin/GetScheduledJobs";
    return this.http.get(url).toPromise();
  }

  getScheduledJob(jobID: number) {
    var url = "/Admin/GetScheduledJob?JobID=" + jobID;
    return this.http.get(url).toPromise();
  }

  getScheduledJobHistory(jobID: number) {
    var url = "/Admin/ScheduledJobHistory?jobID=" + jobID;
    return this.http.get(url).toPromise();
  }

  addOrUpdateScheduledJob(job) {
    var url = "/Admin/AddOrUpdateScheduledJob";
    return this.http.post(url, job).toPromise();
  }

  removeUserDefinedJob(jobID: number) {
    var url = "/Admin/RemoveUserDefinedJob";
    return this.http.post(url, { jobID: jobID }).toPromise();
  }

  executeJobNow(jobID: number) {
    var url = "/Admin/ExecuteJobNow";
    return this.http.post(url, { jobID: jobID }).toPromise();
  }

  getEmployeeGroups() {
    var url = "/Admin/GetEmployeeGroups";
    return this.http.get(url).toPromise();
  }

  sendSMSUserGrouop(userGroupID?: number, sMSSubject?: string, bodyText?: string, messageType?: string, includeOptOut?: boolean, scheduledSendDateStr?: string, scheduleTimeStr?: string) {
    return this.http.post("/Admin/SendSMSUserGrouop", {
      userGroupID: userGroupID,
      sMSSubject: sMSSubject,
      bodyText: bodyText,
      messageType: messageType,
      includeOptOut: includeOptOut,
      scheduledSendDateStr: scheduledSendDateStr,
      scheduleTimeStr: scheduleTimeStr
    }).toPromise();
  }

  getMailLog(requestParam: string) {
    var url = "/Admin/GetMailLog?" + requestParam;
    return this.http.get(url).toPromise();
  }

  getMailQueueProcessSources() {
    var url = "/Admin/GetMailQueueProcessSources";
    return this.http.get(url).toPromise();
  }

  getHangFireEmailStatus() {
    var url = "/Admin/GetHangFireEmailStatus";
    return this.http.get(url).toPromise();
  }

  sendEmailQueueHourly(type: string) {
    return this.http.post("/Admin/SendEmailQueueHourly", {
      type: type
    }).toPromise();
  }

  deleteMailQueueItem(mailQueueID: number) {
    return this.http.post("/Admin/DeleteMailQueueItem", {
      mailQueueID: mailQueueID
    }).toPromise();
  }

  sendTestEmail(mailTo: string) {
    var url = "/Admin/SendTestEmail";
    return this.http.post(url, {mailTo: mailTo}).toPromise();
  }

  forwardEmail(mailQueueID: number, mailTo: string) {
    return this.http.post("/Admin/ForwardEmail", {
      mailQueueID: mailQueueID,
      toEmail: mailTo
    }).toPromise();
  }

  getTrainingCompany() {
    var url = "/Employee/GetTrainingCompany";
    return this.http.get(url).toPromise();
  }

  getClassesToManage(hRCo: number, showTemplates: boolean, trainingClassID?: any) {
    var url = "/Admin/GetClassesToManage?hRCo=" + hRCo + "&showTemplates=" + showTemplates + "&trainingClassID=" + trainingClassID;
    return this.http.get(url).toPromise();
  }

  getChecklistTemplate() {
    var url = "/Admin/GetChecklistTemplate";
    return this.http.get(url).toPromise();
  }

  getRequireCourseSetting() {
    var url = "/Admin/GetRequireCourseSetting";
    return this.http.get(url).toPromise();
  }

  addGroupToClass(trainingClassId: number, userGroupID: number) {
    return this.http.post("/Admin/AddGroupToClass", {
      trainingClassId: trainingClassId,
      userGroupID: userGroupID
    }).toPromise();
  }

  removeGroupFromClass(trainingClassId: number, userGroupID: number) {
    return this.http.post("/Admin/RemoveGroupFromClass", {
      trainingClassId: trainingClassId,
      userGroupID: userGroupID
    }).toPromise();
  }

  hasCompletedChecklist(trainingClassID: number, hasCompletedChecklist: boolean) {
    return this.http.post("/Admin/HasCompletedChecklist", {
      trainingClassID: trainingClassID,
      hasCompletedChecklist: hasCompletedChecklist
    }).toPromise();
  }


  addAttendeeToClass(trainingClassId: any, attendeeUserKeyID: any) {
    return this.http.post("/Admin/AddAttendeeToClass",{
      trainingClassId: trainingClassId,
      attendeeUserKeyID: attendeeUserKeyID
    }).toPromise();
  }

  getGroups() {
    var url= "/Admin/GetUserGroup"
    return this.http.get(url).toPromise();
  }

  removeAttendee(trainingClassAttendeeID: number, trainingClassId: number) {
    return this.http.post("/Admin/RemoveAttendee",{
      trainingClassAttendeeID: trainingClassAttendeeID,
      trainingClassId: trainingClassId
    }).toPromise();
  }

  addCodeToClass(trainingClassId: number, hRCMKeyID: number) {
    return this.http.post("/Admin/AddCodeToClass",{
      trainingClassId: trainingClassId,
      hRCMKeyID: hRCMKeyID
    }).toPromise();
  }

  removeCode(data: { trainingClassId: number; hRCMKeyID: number; }) {
    return this.http.post("/Admin/RemoveCode",{
      trainingClassId: data.trainingClassId,
      hRCMKeyID: data.hRCMKeyID
    }).toPromise();
  }

  createEditClass(data: { [key: string]: any }) {
    return this.http.post("/Admin/CreateEditClass",{
      trainingClassId: data.trainingClassId,
      classDateTimeStr: data.classDateTimeStr,
      classTitle: data.classTitle,
      isClassOpenRegister: data.isClassOpenRegister,
      classInstructorUserKeyID: data.classInstructorUserKeyID,
      hRCo: data.hRCo,
      location: data.location,
      maxAttendeeCount: data.maxAttendeeCount,
      classEndDateTimeStr: data.classEndDateTimeStr,
      checklistTemplateID: data.checklistTemplateID,
      isClassTemplate: data.isClassTemplate,
      templateTrainingClassID: data.templateTrainingClassID,
      expirationDateStr: data.expirationDateStr
    }).toPromise();
  }

  finalizeClass(trainingClassId: number, isFinalized: number, checklistInstanceID?: number) {
    return this.http.post("/Admin/FinalizeClass",{
      trainingClassId: trainingClassId,
      isFinalized: isFinalized,
      checklistInstanceID: checklistInstanceID
    }).toPromise();
  }

  deleteSavedAttachment (file:any) {
    return this.http.post("/Employee/RemoveFileAttachment",{
      fileAttachmentID: file.FileAttachmentID
    }).toPromise();
  }

  getGroupByClass(trainingClassId: number) {
    var url = "/Admin/GetGroupByClass?trainingClassId=" + trainingClassId;
    return this.http.get(url).toPromise();
  }

  getCodesByClass(trainingClassId: number) {
    var url= "/Admin/GetCodesByClass?trainingClassId="+trainingClassId;
    return this.http.get(url).toPromise();
  }

  getAttendeesByClass(trainingClassId: number) {
    var url = "/Admin/GetAttendeesByClass?trainingClassId=" + trainingClassId;
    return this.http.get(url).toPromise();
  }

  getAttendees() {
    var url = "/Admin/GetAttendees";
    return this.http.get(url).toPromise();
  }

  attendeeSign(trainingClassAttendeeID: number, isPresent: boolean, signatureData?: any, signatureLong?: any, signatureLat?: any){
    return this.http.post("/Admin/AttendeeSign",{
      trainingClassAttendeeID: trainingClassAttendeeID,
      isPresent: isPresent,
      signatureData: signatureData,
      signatureLong: signatureLong,
      signatureLat: signatureLat
    }).toPromise();
  }

  attendeeMarkAllPresent(trainingClassID: number) {
    return this.http.post("/Admin/AttendeeMarkAllPresent", { trainingClassID: trainingClassID }).toPromise();
  }

  deleteClass(trainingClassId: number) {
    return this.http.post("/Admin/DeleteClass", {
      trainingClassId: trainingClassId
    }).toPromise();
  }

  getHolidayGroupSet() {
    const url = "/Admin/HolidayGroupsGet";
    return this.http.get(url).toPromise();
  }

  getHolidayCodeAssign(holidayGroupID: number) {
    const url = "/Admin/HolidayCodeAssignGet?holidayGroupID=" + holidayGroupID;
    return this.http.get(url).toPromise();
  }

  getHolidayList(selectedYear: number, selectedCountry: string) {
    const url = "/Admin/GetHolidayList?year=" + selectedYear + "&country=" + selectedCountry;
    return this.http.get(url).toPromise();
  }

  getUserGroupList() {
    const url = "/Admin/GetUserGroup";
    return this.http.get(url).toPromise();
  }

  addUserGroup(holidayGroupID: number, userGroupID: number) {
    const url = "/Admin/HolidayCodeAssignAdd";
    const payload = {
      holidayGroupID: holidayGroupID,
      userGroupID: userGroupID
    }
    return this.http.post(url, payload).toPromise();
  }

  addHolidayGroupName(groupData) {
    const url = "/Admin/HolidayGroupAddUpdate";
    const payload = {
      holidayGroupID: groupData.holidayGroupID,
      holidayGroupName: groupData.holidayGroupName
    }
    return this.http.post(url, payload).toPromise();
  }

  updateHolidayGroupName(groupData) {
    const url = "/Admin/HolidayGroupAddUpdate";
    const payload = {
      holidayGroupID: groupData.holidayGroupID,
      holidayGroupName: groupData.holidayGroupName
    }
    return this.http.post(url, payload).toPromise();
  }

  removeUserGroup(userGroup) {
    const url = "/Admin/HolidayCodeAssignDelete";
    const payload = {
      holidayCodeAssignID: userGroup.HolidayCodeAssignID
    }
    return this.http.post(url, payload).toPromise();
  }

  deleteGroup(holidayGroup) {
    const url = "/Admin/HolidayGroupDelete";
    const payload = { holidayGroupID: holidayGroup.HolidayGroupID }
    return this.http.post(url, payload).toPromise();
  }

  addHoliday(holidayData) {
    const url = "/Admin/HolidayAddEdit";
    const payload = {
      holidayID: holidayData.holidayID,
      holidayGroupID: holidayData.holidayGroupID,
      holidayDateStr: holidayData.holidayDateStr,
      holidayName: holidayData.holidayName,
      holidayDescription: holidayData.holidayDescription,
      isPartialDay: holidayData.isPartialDay
    }
    return this.http.post(url, payload).toPromise();
  }

  deleteHoliday(holiday) {
    const url = "/Admin/HolidayDelete";
    const payload = {
      holidayID: holiday.HolidayID
    }
    return this.http.post(url, payload).toPromise();
  }

  getHolidayByGroupID(holidayGroupID: number) {
    const url = "/Admin/HolidaysGetByGroupID?holidayGroupID=" + holidayGroupID;
    return this.http.get(url).toPromise();
  }
  
  getPRGroups(company: any) {
    return this.http.get("/Admin/GetPRGroups?company=" + company).toPromise();
  }

  getEmployeesByPRCoAndPRGroup(pRCo: any, pRGroup: any) {
    return this.http.get("/Admin/GetEmployeesByPRCoAndPRGroup?pRCo=" + pRCo + "&pRGroup=" + pRGroup).toPromise();
  }

  getVistaVersion() {
    var url = "/Admin/GetVistaVersion";
    return this.http.get(url).toPromise();
  }

  getEmailTemplates(emailTemplateID?: number, reqID?: any) {
    var url = "/Admin/GetEmailTemplates?reqID=" + reqID;
    return this.http.get(url).toPromise();
  }

  evaluateEmailTemplateVerbiage(onboardID?: any, reqID?: any, emailTemplateID?: number, templateBody?: string, templateSubject?: string, sendEmail?: boolean, templateTo?: string) {
    var url = "/Admin/EvaluateEmailTemplateVerbiage?onboardID=" + onboardID + "&reqID=" + reqID + "&emailTemplateID=" + emailTemplateID;
    return this.http.get(url).toPromise();
  }
  
}